
import PolygonSides from '../../../element/icons/polygon-sides';


import PolygonSidesField from './PolygonSidesField';

export const SIDES_NUMBER = 'sides-number';

/** Banner-friendly range: triangle (3) through dodecagon (12). */
export const POLYGON_SIDES_MIN = 3;
export const POLYGON_SIDES_MAX = 12;

export const POLYGON_POPPABLE_OPTIONS = [
  {
    titleKey: 'sides',
    name: SIDES_NUMBER,
    Icon: PolygonSides,
  },
];

export const polygonOptionsPopupComponents = {
  [SIDES_NUMBER]: PolygonSidesField,
};
